import { RioApiGet } from "rio.react.all";
import { OrganisationApiModel } from "../apiModels/OrganisationApiModel";

export class OrganisationApi {

    static getOrganisations() {
        return RioApiGet.asPromise<Array<OrganisationApiModel>>("/api/organisation/get");
    }
}